import intl from "react-intl-universal";
import { TbServer } from "react-icons/tb";
import { useBaasInstance } from "../../../../Contexts/BaasInstanceContext";
import {
  BAAS_LIST_FILTER_ALL,
  BAAS_LIST_FILTER_VALUT,
  canUseBaasGlobalInstanceFilter,
  getBaasListInstanceFilterOptions,
} from "../baasInstanceListFilter";

/**
 * App-header instance filter (matriz only). Default = Todas (full network).
 * Partners never see this — their console pin is already their instance.
 */
export const BaasInstanceFilterSelect = ({ className = "" }) => {
  const {
    instances,
    selectedInstance,
    listInstanceFilter,
    setListInstanceFilter,
  } = useBaasInstance();

  if (!canUseBaasGlobalInstanceFilter(selectedInstance)) {
    return null;
  }

  const { matrix, others } = getBaasListInstanceFilterOptions(instances, selectedInstance);
  const valutLabel =
    matrix?.displayName ||
    matrix?.name ||
    intl.get("baas.nav.instanceFilter.valut");

  return (
    <label
      className={`flex min-w-0 max-w-[9.5rem] items-center gap-1.5 sm:max-w-[14rem] ${className}`.trim()}
    >
      <TbServer className="hidden h-3.5 w-3.5 shrink-0 text-gray-400 min-[400px]:block" aria-hidden />
      <span className="sr-only">{intl.get("baas.nav.instanceFilter.label")}</span>
      <select
        value={listInstanceFilter || BAAS_LIST_FILTER_ALL}
        onChange={(event) => setListInstanceFilter(event.target.value)}
        className="h-8 min-w-0 max-w-full truncate rounded-lg border border-gray-200 bg-white px-2 text-[0.65rem] font-semibold text-brand-dark outline-none transition hover:border-gray-300 focus:border-[#e7a73f] dark:border-brand-dark-border dark:bg-brand-dark-elevated dark:text-gray-100 sm:h-9 sm:px-3 sm:text-xs"
        aria-label={intl.get("baas.nav.instanceFilter.label")}
      >
        <option value={BAAS_LIST_FILTER_ALL}>
          {intl.get("baas.nav.instanceFilter.all")}
        </option>
        <option value={BAAS_LIST_FILTER_VALUT}>{valutLabel}</option>
        {others.map((instance) => (
          <option key={instance.id} value={instance.id}>
            {instance.label}
          </option>
        ))}
      </select>
    </label>
  );
};
